import React from 'react';
import FullPageMessage from '../../Components/FullPageMessage';
export const HTTP404 = () => {
    return React.createElement(FullPageMessage, { title: "404", description: "Tyv\u00E4rr, sidan kunde inte hittas." });
};
export default HTTP404;
